import { FormObjType } from "DataTypes/Form";

export const ResultForm: FormObjType[] = [
  {
    id: "resultName",
    label: "Result Name",
    placeholder: "Enter Result Name",
    boxType: "input",
    boxSize: 4,
    validatetype: "any",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "observationName",
    label: "Observation Name",
    placeholder: "Enter Observation Name",
    boxType: "input",
    boxSize: 4,
    validatetype: "any",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "dateTime",
    label: "Observation Date",
    placeholder: "Select Observation Date",
    boxType: "date",
    boxSize: 4,
    validatetype: "date",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "status",
    label: "Status",
    placeholder: "Select Status",
    boxType: "single-select",
    boxSize: 4,
    validatetype: "dropdown",
    required: true,
    enableFormLoad: true,
    dropArr: [
      { id: "Normal", label: "Normal", value: "Normal" },
      { id: "Abnormal", label: "Abnormal", value: "Abnormal" },
      { id: "Unknown", label: "Unknown", value: "Unknown" },
    ],
  },
  {
    id: "observationValue",
    label: "Observation Value",
    placeholder: "Enter Observation Value",
    boxType: "input",
    boxSize: 4,
    validatetype: "any",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "observationUnit",
    label: "Observation Unit",
    placeholder: "Enter Observation Unit",
    boxType: "input",
    boxSize: 4,
    validatetype: "any",
    required: true,
    enableFormLoad: true,
  },
]
